"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var houston_styles_1 = tslib_1.__importStar(require("@eduzz/houston-styles"));
var Paragraph_1 = tslib_1.__importDefault(require("@eduzz/houston-ui/Typography/Paragraph"));
var Text = function (_a) {
    var children = _a.children, className = _a.className, disableTypography = _a.disableTypography, rest = tslib_1.__rest(_a, ["children", "className", "disableTypography"]);
    if (disableTypography) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
    return ((0, jsx_runtime_1.jsx)(Paragraph_1.default, tslib_1.__assign({ className: className, size: 'sm', color: 'neutralColor.low.medium' }, rest, { children: children })));
};
exports.default = (0, houston_styles_1.default)(Text, { label: 'hst-showcase-text' })(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, houston_styles_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme.spacing.inset.sm);
});
var templateObject_1, templateObject_2;
